import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import { setupUIBindingForReactFunctionalComponent } from '@tableau/react-mvvm';
import { EmptyStateContentSuggestionViewModel } from '../viewModels/EmptyStateContentSuggestionViewModel';
import { renderContentSuggestionItems } from './ContentSuggestion';
import { section, sectionHeader, sectionHeaderTitle } from './OmniboxV2Styles';

export function EmptyStateContentSuggestion(props: { viewModel: EmptyStateContentSuggestionViewModel }): JSX.Element {
    const viewModel = props.viewModel;
    setupUIBindingForReactFunctionalComponent(viewModel);

    return <div className={[section, 'tb-quicklinks-section-divider'].join(' ')}>
        <div className={sectionHeader}>
            <h2 className={sectionHeaderTitle}>{Messages.contentSuggestionSectionTitle()}</h2>
        </div>
        {renderContentSuggestionItems(viewModel)}
    </div>
}
